import { UserApi } from "../../../common/constants/user-api";
import { getResponseData } from "../../../common/utils/api-utils";

export async function checkIsEmailUnique(email: string) {
    const url = new URL(`${UserApi.findUser}/${email}`);
    return await getResponseData(
      new Request(url.toString(), {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      })
    );
  }
  